import { Section, FormWrapper, Hero, CallToAction, Title } from "./Home.styles";
import Layout from "../../containers/Layout";
import t from "../../localizations/index";
import useTitle from "../../hooks/useTitle";
import Accordion from "../../components/Accordion";
import FormSliderWithInput from "../../components/FormSliderWithInput2";
import { Controller, useForm } from "react-hook-form";

import { steps } from "../../utils/constants";

const minLoanAmount = 500;
const maxLoanAmount = 30000;

export const getMinRule = (value) => ({
  min: { value, message: `msg_error_field_less_than_min_value', ${value}` },
});

export const getMaxRule = (value) => ({
  max: { value, message: `msg_error_field_more_than_max_value', ${value}` },
});

export const requiredRule = { required: { value: true, message: "msg_error_field_required" } };

function Home() {
  useTitle(t.pages.home.documentTitle);
  const form = useForm({
    mode: "onSubmit",
    defaultValues: {
      amount: 10000,
    },
  });

  const handleCtaClick = (e) => {
    e.preventDefault();
    const amount = form.getValues('amount');
    window.location.href = `${process.env.REACT_APP_API_URL}/?type=consume&amount=${amount}`;
  };

  const handleApplicationFormSubmit = (values) => {
    window.location.href = `${process.env.REACT_APP_API_URL}/?type=consume&amount=${values?.amount}`;
  };

  const returnView = () => {
    return (
      <FormWrapper>
        <h1 className="title">{t.pages.home.hero.title}</h1>
        <p className="subtitle">{t.pages.home.hero.text}</p>

        <form onSubmit={form.handleSubmit(handleApplicationFormSubmit)} id="home-form">
          <div className="input-block">
            <Controller
              name="amount"
              control={form.control}
              rules={{
                ...requiredRule,
                ...getMinRule(minLoanAmount),
                ...getMaxRule(maxLoanAmount),
              }}
              render={(controllerProps) => (
                <FormSliderWithInput
                  {...controllerProps}
                  min={minLoanAmount}
                  max={maxLoanAmount}
                  step={minLoanAmount}
                  values={steps}
                  label="Paskolos suma"
                  suffix="€"
                  id="loanAmount"
                />
              )}
            />
          </div>

          <div className="input-block">
            <button className="submitButton" type="submit">
              {t.pages.home.hero.btnText}
            </button>
          </div>
        </form>
      </FormWrapper>
    );
  };

  return (
    <Layout>
      <Hero>
        <div className="wrapper">{returnView()}</div>
      </Hero>
      <Section>
        <div className="wrapper">
          <Title className="decorated black">{t.pages.home.lowerInterest.title}</Title>
          <p>
            <span dangerouslySetInnerHTML={{ __html: t.pages.home.lowerInterest.text }} />
          </p>
          <a className="btn btn-primary cta-btn" onClick={handleCtaClick} href="">
            {t.pages.home.lowerInterest.btnText}
          </a>
        </div>
      </Section>
      <Section className="easyLoan">
        <div className="wrapper">
          <Title className="title">{t.pages.home.easyLoan.title}</Title>
          <div className="row">
            <div className="col col-12 col-lg-4">
              <img alt="img" src="./assets/images/step1.png.webp" loading="lazy" />
              <h6 className="title">{t.pages.home.easyLoan.col1.title}</h6>
              <div className="text">{t.pages.home.easyLoan.col1.text}</div>
            </div>
            <div className="col col-12 col-lg-4">
              <img alt="img" src="./assets/images/step2.png.webp" loading="lazy" />
              <h6 className="title">{t.pages.home.easyLoan.col2.title}</h6>
              <div className="text">{t.pages.home.easyLoan.col2.text}</div>
            </div>
            <div className="col col-12 col-lg-4">
              <img alt="img" src="./assets/images/step3.png.webp" loading="lazy" />
              <h6 className="title">{t.pages.home.easyLoan.col3.title}</h6>
              <div className="text">{t.pages.home.easyLoan.col3.text}</div>
            </div>
          </div>
        </div>
      </Section>
      <Section className="moreThan">
        <div className="wrapper">
          <Title className="decorated black">{t.pages.home.moreThan.title}</Title>
          <div className="row">
            <div className="col col-12 col-lg-4">
              <img alt="img" src="/assets/images/like.png" />
              <h6 className="title">{t.pages.home.moreThan.col1.title}</h6>
              <div className="text">{t.pages.home.moreThan.col1.text}</div>
            </div>
            <div className="col col-12 col-lg-4">
              <img alt="img" src="/assets/images/like.png" />
              <h6 className="title">{t.pages.home.moreThan.col2.title}</h6>
              <div className="text">{t.pages.home.moreThan.col2.text}</div>
            </div>
            <div className="col col-12 col-lg-4">
              <img alt="img" src="/assets/images/like.png" />
              <h6 className="title">{t.pages.home.moreThan.col3.title}</h6>
              <div className="text">{t.pages.home.moreThan.col3.text}</div>
            </div>
          </div>
        </div>
      </Section>
      <Section>
        <div className="wrapper">
          <Title className="decorated">{t.pages.home.dataProtection.title}</Title>
          <p>
            <span dangerouslySetInnerHTML={{ __html: t.pages.home.dataProtection.text }} />
          </p>
          <div className="images">
            <a href="https://www.lb.lt/en/sfi-financial-market-participants/rego-lt-uab" target="_blank">
              <img alt="lietuvos-bankas-logo" src="/assets/images/1_LB.png" loading="lazy" />
            </a>
            <img alt="ada-logo" src="/assets/images/2_ADA.png" loading="lazy" />
            <img alt="ssl-logo" src="/assets/images/3_SSL.png.webp" loading="lazy" />
          </div>
        </div>
      </Section>
      <Section className="faq">
        <div className="wrapper">
          <Title className="decorated">{t.pages.home.faq.title}</Title>
          <Accordion list={t.pages.home.faq.faqList} id="faq-accordion" />
        </div>
      </Section>
      <Section>
        <div className="wrapper">
          <Title className="decorated">{t.pages.home.loanExample.title}</Title>
          <p>
            <span
              dangerouslySetInnerHTML={{
                __html: t.pages.home.loanExample.text,
              }}
            />
          </p>
        </div>
      </Section>
      <CallToAction>
        <div className="wrapper">
          <Title>{t.pages.home.callToAction.title}</Title>
          <a className="btn btn-primary cta-btn" onClick={handleCtaClick} href="/">
            {t.pages.home.callToAction.btnText}
          </a>
        </div>
      </CallToAction>
    </Layout>
  );
}

export default Home;
